<template>
  <div>
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-toolbar color="transparent" flat>
      <v-btn flat fab icon @click="back()">
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
          <!-- <v-btn :disabled="btnSave" color="green" outline dark @click="onSubmit()">Save</v-btn>
          <v-btn color="red" outline dark @click="back()">Cancel</v-btn> -->
    </v-toolbar>
    
    <v-divider></v-divider>

    <v-container class="form-container elevation-1">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field v-model="form.name" label="Name *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea outline v-model="form.description" label="Description"></v-textarea>
          </v-flex>
         
        </v-layout>
        <v-card-actions>
          <v-btn :disabled="btnSave" color="green" dark @click="onSubmit()">Save </v-btn>
          <v-btn color="red" dark @click="back()">Cancel</v-btn>
        </v-card-actions>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create Theme",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Tour Theme",
          disabled: false,
          to: "/tourTheme"
        },
        {
          text: "Create Theme",
          disabled: true,
          to: "/createTourTheme"
        }
      ],

      form: {
        name: null,
        description: null
      }
    };
  },

  mounted() {
    },

  methods: {
    back() {
      this.$router.go(-1);
    },


    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        let themeCode = "TT" + Math.floor(100000000000 + Math.random() * 900000000000);
        this.axios
          .post(
            config.API + `TourThemes`,
            {
              themeCode: themeCode,
              name: this.form.name,
              description: this.form.description
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Tour Theme successfully created");
            this.$router.push("/imageTourTheme/" + themeCode);
            //this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  },
};
</script>

<style>
</style>
